var version = {
    "name":      "dativery",
    "buildDateCode": "20260205-164515",
    "buildDate": "Thu Feb 05 2026 16:45:15 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260205-164515",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;